export const FRANTIC_TAGLINE =
  'A tribe of like-minded companions on a quest for success and fulfillment';
export const FRANTIC_DESCRIPTION = `Feeling exhausted, overwhelmed, and alone? The struggle to get ahead (or simply not fall behind) doesn’t have to be so hard.`;
export const FRANTIC_CTA = 'Join the Adventure';
export const FRANTIC_CLIFFHANGER = 'Join us, be free, and succeed.';
export const FRANTIC_NAV_BAR_BUTTON_TEXT = 'Take the Quiz';
